import { request } from "@/api/http";

export default {
  getTemplate(data) {
    return request({
      url: "/api/RecycleOrder/GetTemplate",
      method: "POST",
      data,
    });
  },

  // 努比亚重新估价入口只传 evaluateId 时，先取订单确认信息里的 spuId 再拉模板。
  getPreSubmitOrderInfo(data) {
    return request({
      url: "/api/NubiaRecycle/GetPreSubmitOrderInfo",
      method: "POST",
      data,
      baseURLKey: "B",
    });
  },

  getCategory(data) {
    return request({
      url: "/api/NubiaRecycle/GetCategory",
      method: "POST",
      data,
      baseURLKey: "B",
    });
  },

  // 识别当前设备机型，分类页“本机”卡片使用接口返回的真实 SPU 信息。
  getLocalModel(data) {
    return request({
      url: "/api/NubiaRecycle/GetLocalModel",
      method: "POST",
      data,
      baseURLKey: "B",
    });
  },

  // 查询 SPU 信息，用于搜索页按关键字分页加载商品。
  searchSpu(data) {
    return request({
      url: "/api/NubiaRecycle/SearchSpu",
      method: "POST",
      data,
      baseURLKey: "B",
    });
  },

  getQuotePrice(data) {
    return request({
      url: "/api/NubiaRecycle/GetQuotePrice",
      method: "POST",
      data,
      baseURLKey: "B",
    });
  },

  getRewardInfo(data) {
    return request({
      url: "/api/NubiaOrder/GetRewardInfo",
      method: "POST",
      data,
      baseURLKey: "B",
    });
  },

  getPromiseCalendar(data) {
    return request({
      url: "/api/RecycleOrder/GetPromiseCalendar",
      method: "POST",
      data,
    });
  },

  renewPlaceOrder(data) {
    return request({
      url: "/api/NubiaOrder/RenewPlaceOrder",
      method: "POST",
      data,
      baseURLKey: "B",
    });
  },

  getOrderDetail(data) {
    return request({
      url: "/api/NubiaRecycle/GetOrderDetail",
      method: "POST",
      data,
      baseURLKey: "B",
    });
  },

  // 客户修改预约信息，服务端统一处理订单同步、日志和快递预约变更。
  updateAppointment(data) {
    return request({
      url: "/api/NubiaRecycle/UpdateAppointment",
      method: "POST",
      data,
      baseURLKey: "B",
    });
  },

  getQuoteReport(data) {
    return request({
      url: "/api/NubiaRecycle/GetQuoteReport",
      method: "POST",
      data,
      baseURLKey: "B",
    });
  },

  // 取消努比亚回收订单，订单详情页确认取消后调用。
  cancelOrder(data) {
    return request({
      url: "/api/NubiaRecycle/CancelOrder",
      method: "POST",
      data,
      baseURLKey: "B",
    });
  },

  // 获取努比亚订单物流轨迹，物流详情页按订单号和用户 ID 加载真实物流数据。
  getLogisticsRoute(data) {
    return request({
      url: "/api/NubiaRecycle/GetLogisticsRoute",
      method: "POST",
      data,
      baseURLKey: "B",
    });
  },

  // 提交自寄物流信息，填写物流页确认提交后调用。
  submitLogistics(data) {
    return request({
      url: "/api/NubiaRecycle/SubmitLogistics",
      method: "POST",
      data,
      baseURLKey: "B",
    });
  },

  // 获取努比亚订单质检报告，验机评估报告页按订单号和用户 ID 拉取最终检测结果。
  getCheckReport(data) {
    return request({
      url: "/api/NubiaRecycle/GetCheckReport",
      method: "POST",
      data,
      baseURLKey: "B",
    });
  },

  getExpressList(data = {}) {
    return request({
      url: "/api/MyRecycleOrder/GetExpressList",
      method: "POST",
      data,
    });
  },

  // 获取订单取消原因列表，用于订单详情页取消订单弹窗。
  getCancelReasonList(data) {
    return request({
      url: "/api/MyRecycleOrder/GetCancelReasonList",
      method: "POST",
      data,
    });
  },

  checkAddress(data) {
    return request({
      url: "/api/RecycleOrder/CheckAddress",
      method: "POST",
      data,
    });
  },

  // 红魔联合登录回调：把红魔回跳带回的 code/sign 等原样透传给后端验签解密，成功返回 { userId, userName }。
  nubiaUserLogin(data) {
    return request({
      url: "/api/NubiaRecycle/UserLogin",
      method: "POST",
      data,
      baseURLKey: "B",
    });
  },
};
